'use client'

import * as React from 'react'
import { Button } from '@repo/design-system-cf/components/button'
import { InlineStaticVariant } from '@repo/web-ui/components/static-variants-renderer/inline/inline-static-variant'
import {
  DOES_NOT_HAVE_ALL_ACCESS,
  LOGGED_IN,
  LOGGED_OUT,
} from '@repo/web-ui/components/static-variants-renderer/utils/conditions'
import {
  PAYMENT_ENTRY_POINTS,
  savePaymentModalEntryPoint,
} from 'payments/payments-dialog/analytics'
import { AmplitudeEvents, sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'
import { useStartFreeTrial } from 'payments/start-free-trial-button/hooks/use-start-free-trial'

export function InlineStaticVariantBanner({ banner }: { banner: React.ReactNode }) {
  return (
    <>
      <InlineStaticVariant
        conditions={[LOGGED_OUT]}
        getVariant={({ conditionsMet }) => (conditionsMet ? <>{banner}</> : null)}
      />
      <InlineStaticVariant
        conditions={[LOGGED_IN, DOES_NOT_HAVE_ALL_ACCESS]}
        getVariant={({ conditionsMet }) => (conditionsMet ? <>{banner}</> : null)}
      />
    </>
  )
}

export function FreeTrialButton({ children }: { children: React.ReactNode }) {
  const { startFreeTrial } = useStartFreeTrial()
  return (
    <Button
      variant="primary-green-bright"
      className="uppercase text-16 hover:text-cf-white hover:bg-[#248142] mx-auto rounded-[1px] p-2.5 !px-3"
      onClick={async () => {
        savePaymentModalEntryPoint(PAYMENT_ENTRY_POINTS.TAGS_FREE_TRIAL_BANNER)
        sendAmplitudeEvent(AmplitudeEvents.FREE_TRIAL_BUTTON_CLICKED)
        await startFreeTrial()
      }}
    >
      {children}
    </Button>
  )
}
